module.exports = __webpack_public_path__ + "static/media/Hunter-Molnar.3359558e.jpg";